import { graphql } from "../../gql";

export const DASHBOARD_CARDS_QUERY = graphql(/* GraphQL */ `
	query DashboardCards {
		dashboardCards
	}
`);
